import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  clearStorage,
  getStorage,
  setStorage,
  setUserStorage,
} from '../utils/StorageHelper';

const baseURL = `${process.env.REACT_APP_API}/api/v1`;
const TOKEN_KEY = 'anfavea_token';
export const api = axios.create({
  baseURL,
  headers: {
    Authorization: 'Bearer ' + getStorage(TOKEN_KEY),
    'Cache-Control': 'max-age=300',
  },
});

const REFRESH_TOKEN_KEY = 'anfavea_ref_token';
let USER_KEY = '@logged_user';

export const getToken = (): any | undefined => {
  return getStorage(TOKEN_KEY);
};

export const setToken = (token: string) => {
  setStorage(TOKEN_KEY, token);
};

export const setRefreshToken = (refreshToken: string) => {
  setStorage(REFRESH_TOKEN_KEY, refreshToken);
};

export const getRefreshToken = (): any | undefined => {
  return getStorage(REFRESH_TOKEN_KEY);
};

export const removeRefreshToken = () => {
  clearStorage(REFRESH_TOKEN_KEY);
};

export const removeToken = () => {
  clearStorage(TOKEN_KEY);
};

export const addUserStorage = (user: string) => {
  setUserStorage(USER_KEY, user);
};

export const getUserStorage = (): any => {
  return getStorage(USER_KEY);
};

async function refreshAccessToken() {
  const user = getUserStorage();
  const userData = JSON.parse(user);
  const REFRESH_TOKEN = getRefreshToken();
  const userOutlook = Boolean(localStorage.getItem('@user_Outlook'));

  const body = {
    email: userData.email,
    refreshToken: REFRESH_TOKEN,
  };

  const endpoint = userOutlook
    ? '/AutenticacaoMicrosoft/refreshToken'
    : '/auth/refresh';

  try {
    const response = await api.post(endpoint, body);
    return { status: response.status, content: response?.data?.content };
  } catch (error) {
    console.error('Erro ao atualizar token:', error);
    throw error;
  }
}

export async function refreshToken() {
  try {
    const response = await refreshAccessToken();
    const { token, refreshToken } = response?.content;

    api.defaults.headers[
      'Authorization'
    ] = `Bearer ${token}?timestamp=${new Date().getTime()}`;

    setToken(token);
    setRefreshToken(refreshToken);

    return token;
  } catch (error: any) {
    // Trate o erro, se necessário
    throw error;
  }
}

let isRefreshing = false;
let failedRequestsQueue: any[] = [];

function logoutUser(error: any) {
  removeToken();
  removeRefreshToken();

  failedRequestsQueue.forEach((req: any) => req.onFailure(error));
  failedRequestsQueue = [];

  localStorage.removeItem('@logged_user');
  window.location.href = '/';
}

api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    const errorIsFromAccessToken =
      error?.response?.data?.Error === 'Sessão inválida';

    if (error.response.status === 401 && !errorIsFromAccessToken) {
      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshToken();
          originalConfig.headers['Authorization'] = `Bearer ${newToken}`;

          failedRequestsQueue.forEach((req: any) => req.onSuccess(newToken));
          failedRequestsQueue = [];

          return api(originalConfig);
        } catch (error: any) {
          logoutUser(error);
          return Promise.reject(error);
        } finally {
          isRefreshing = false;
        }
      }

      return new Promise((resolve, reject) => {
        failedRequestsQueue.push({
          onSuccess: (token: string) => {
            originalConfig.headers['Authorization'] = `Bearer ${token}`;

            resolve(api(originalConfig));
          },
          onFailure: (error: AxiosError) => {
            reject(error);
          },
        });
      });
    }

    if (errorIsFromAccessToken) {
      logoutUser(error);
    }

    return Promise.reject(error);
  },
);
